import React, { lazy, Suspense } from "react";

const LazyPrintSalary = lazy(() => import("./PrintSalary"));
const LazyPunshedFormList = lazy(() => import("./PunshedFormList"));
const LazySalaryForm = lazy(() => import("./SalaryForm"));
const LazyPrintSalaryForm = lazy(() => import("./PrintSalaryForm"));
const LazyPersentageForm = lazy(() => import("./PersentageForm"));
const LazyPrintPersentage = lazy(() => import("./PrintPersentage"));
const LazyPrintPunshed = lazy(() => import("./PrintPunshed"));
const LazyRePrintMasrufat = lazy(() => import("./RePrintMasrufat"));
const LazyReAccounting = lazy(() => import("./ReAccounting"));
const LazyListMasrufBranch = lazy(() => import("./ListMasrufBranch"));
const LazyCurrencyPrice = lazy(() => import("./CurrencyPrice"));
export const CurrencyPrice = () => (
  <Suspense fallback="loading...">
    <LazyCurrencyPrice />
  </Suspense>
);
export const PunshedFormList = () => (
  <Suspense fallback="loading...">
    <LazyPunshedFormList />
  </Suspense>
);
export const SalaryForm = () => (
  <Suspense fallback="loading...">
    <LazySalaryForm />
  </Suspense>
);
export const PrintSalaryForm = () => (
  <Suspense fallback="loading...">
    <LazyPrintSalaryForm />
  </Suspense>
);
export const PrintSalary = () => (
  <Suspense fallback="loading...">
    <LazyPrintSalary />
  </Suspense>
);
export const PersentageForm = () => (
  <Suspense fallback="loading...">
    <LazyPersentageForm />
  </Suspense>
);
export const PrintPersentage = () => (
  <Suspense fallback="loading...">
    <LazyPrintPersentage />
  </Suspense>
);
export const PrintPunshed = () => (
  <Suspense fallback="loading...">
    <LazyPrintPunshed />
  </Suspense>
);
export const RePrintMasrufat = () => (
  <Suspense fallback="loading...">
    <LazyRePrintMasrufat />
  </Suspense>
);
export const ReAccounting = () => (
  <Suspense fallback="loading...">
    <LazyReAccounting />
  </Suspense>
);
export const ListMasrufBranch = () => (
  <Suspense fallback="loading...">
    <LazyListMasrufBranch />
  </Suspense>
);
